import { ParseKeys } from 'i18next'
import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { openBlobFile } from '~/shared/lib/file/openBlobFile'
import { logger } from '~/shared/lib/logger'
import { snackbarEnqueued } from '~/shared/lib/notifications'
import { Button } from '~/shared/ui/Buttons'
import { FileIcon } from '~/shared/ui/Icons'

type TitleOnly = {
  title: string
  titleI18n?: never
}

type TitleI18nOnly = {
  title?: never
  titleI18n: ParseKeys
}

type RequiredTitle = TitleOnly | TitleI18nOnly

type FileExportBlobProps = {
  fn: () => Promise<Blob> | void | Blob
  target?: '_self' | '_blank' | '_parent' | '_top'
} & RequiredTitle

export function FileExportBlob({
  fn,
  titleI18n,
  title,
  target = '_self',
}: FileExportBlobProps) {
  const { t } = useTranslation()
  const [isLoading, toggleIsLoading] = useState(false)

  const handlePrintFile = useCallback(async () => {
    try {
      toggleIsLoading(true)
      const response = await fn()

      if (!response) return

      openBlobFile(response, target)
    } catch (e) {
      logger.error(e)
      snackbarEnqueued({
        messageI18n: 'alert.file receipt error',
        variant: 'error' as const,
      })
    } finally {
      toggleIsLoading(false)
    }
  }, [fn, target])

  return (
    <Button
      startDecorator={<FileIcon />}
      onClick={handlePrintFile}
      loading={isLoading}
      variant='gray'
    >
      {title ?? t(titleI18n)}
    </Button>
  )
}
